import _clonedeep from 'lodash.clonedeep'
import * as types from '../../types/conversations'

const replyInfoObj = {
  text: '',
  date: '',
  attachments: [],
  buttons: []
}

const initialComposerState = {
  showEmojis: false,
  messageType: 'text',
  sending: false,
  uploading: false,
  message: '',
  files: [],
  errors: {},
  tag: null,
  selectedTemplate: null,
  buttons: [],
  suggestions: [], // Object -> { logId: string, id: string, content: string, confidence: number, attachments: [object], buttons: [object] }
  addExternalText: '',
  chatmailHeader: {},
  messageId: '',
  draftToEdit: '',
  currentSubject: {},
  isDeferred: false,
  deferredDate: '',
  isSurvey: false,
  subjectState: null,
  isWallEnabledForSMS: false,
  inReplyTo: '',
  replyInfo: replyInfoObj,
  variables: []
}

export default function composer(state = _clonedeep(initialComposerState), action) {
  switch (action.type) {
    case types.COMPOSER_SET_TAG: {
      const { tag } = action

      return Object.assign({}, state, {
        tag,
        isSurvey: false,
        selectedTemplate: null,
        message: '',
        buttons: [],
        files: [],
        messageType: 'text',
        addExternalText: ''
      })
    }

    case types.COMPOSER_SET_TEMPLATE: {
      const { payload } = action

      return Object.assign({}, state, { ...payload, messageType: 'text', isSurvey: false, inReplyTo: '', replyInfo: _clonedeep(replyInfoObj) })
    }

    case types.COMPOSER_EDIT_MESSAGE: {
      const { message } = action

      return Object.assign({}, state, { message, addExternalText: '' })
    }

    case types.COMPOSER_ADD_EXTERNAL_TEXT: {
      const { addExternalText } = action

      return Object.assign({}, state, { addExternalText, message: addExternalText, isSurvey: false })
    }

    case types.COMPOSER_SET_CHATMAIL_HEADER: {
      const { chatmailHeader } = action

      return Object.assign({}, state, { chatmailHeader })
    }

    case types.COMPOSER_SET_REPLY_MESSAGE: {
      const { messageId } = action

      return Object.assign({}, state, { messageId })
    }

    case types.COMPOSER_SET_DRAFT_TO_EDIT: {
      const { draftToEdit } = action

      return Object.assign({}, state, { draftToEdit })
    }

    case types.COMPOSER_SET_CURRENT_SUBJECT: {
      const { currentSubject } = action

      return Object.assign({}, state, { currentSubject })
    }

    case types.USER_UPDATE_CHATMAIL: {
      const { subjectState } = action

      return Object.assign({}, state, { subjectState })
    }

    case types.COMPOSER_EDIT_BUTTONS: {
      const { buttons } = action
      return Object.assign({}, state, { buttons })
    }

    case types.COMPOSER_SET_SURVEY: {
      return Object.assign({}, state, { isSurvey: true, addExternalText: '' })
    }

    case types.COMPOSER_SEND: {
      return Object.assign({}, state, {
        sending: true,
        errors: {},
        addExternalText: '',
      })
    }

    case types.COMPOSER_SENT: {
      const { errors = {} } = action
      return Object.assign({}, state, {
        sending: false,
        uploading: false,
        errors,
        addExternalText: '',
      })
    }

    case types.COMPOSER_UPLOADING_FILES: {
      return Object.assign({}, state, {
        uploading: true,
        errors: {},
      })
    }

    case types.COMPOSER_SET_FILES: {
      const { newFiles } = action
      return Object.assign({}, state, {
        files: [].concat(newFiles),
        uploading: false,
        errors: {},
      })
    }

    case types.COMPOSER_ADD_FILES: {
      const { newFiles, replace } = action
      const files = !replace ? [].concat(state.files, newFiles) : newFiles
      return Object.assign({}, state, {
        files,
        uploading: false,
        errors: {},
      })
    }

    case types.COMPOSER_REMOVE_FILES: {
      const { fileId } = action

      if (state.uploading) return state

      const files = [].concat(state.files)

      files.splice(fileId, 1)

      return Object.assign({}, state, {
        files,
        errors: {},
      })
    }

    case types.COMPOSER_CHANGE_MESSAGE_TYPE: {
      const { messageType } = action

      const remove = messageType === 'note' ? { tag: null, selectedTemplate: null, buttons: [], inReplyTo: '', replyInfo: _clonedeep(replyInfoObj) } : {}

      return Object.assign({}, state, { messageType, ...remove, isSurvey: false })
    }

    case types.COMPOSER_SET_REPLY: {
      const { inReplyTo, replyInfo } = action

      return Object.assign({}, state, { messageType: 'text', inReplyTo, replyInfo: { ..._clonedeep(replyInfoObj), ...replyInfo } })
    }

    case types.COMPOSER_REMOVE_REPLY: {
      return Object.assign({}, state, { messageType: 'text', inReplyTo: '', replyInfo: _clonedeep(replyInfoObj) })
    }

    case types.COMPOSER_RESET: {
      const { persistFields } = action

      const newState = { ..._clonedeep(initialComposerState) }

      if (persistFields?.length) {
        for (const field of persistFields) {
          newState[field] = state[field]
        }
      }

      return Object.assign({}, newState)
    }

    case types.SET_SUGGESTIONS: {
      const { suggestions } = action

      return Object.assign({}, state, { suggestions })
    }

    case types.REJECT_SUGGESTIONS: {
      const { suggestion } = action

      return Object.assign(
        {},
        state,
        {
          suggestions: state.suggestions.filter(elem => elem.id !== suggestion.id)
        }
      )
    }

    case types.TOGGLE_DEFERRED: {
      return Object.assign({}, state, { isDeferred: action.isDeferred })
    }

    case types.SET_DEFERRED_DATE: {
      return Object.assign({}, state, { deferredDate: action.deferredDate })
    }

    case types.COMPOSER_SET_WALL_ENABLED_SMS: {
      return Object.assign({}, state, { isWallEnabledForSMS: action.isWallEnabledForSMS })
    }

    case types.COMPOSER_SET_VARIABLES: {
      return Object.assign({}, state, { variables: action.variables })
    }

    default: {
      return state
    }
  }
}
